module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-st.67a97698.png";